import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { INVENTORY_SETUP, SUB_MODULE } from "../apiRoutes";

interface InventorySetupResponse {
  data: any;
}

const fetchInventorySetupDetail = async (id: string) => {
  const response = await axiosAuth.get<InventorySetupResponse>(
    `${INVENTORY_SETUP}${id}`
  );
  return response.data;
};

const useGetInventorySetupDetailQuery = (
  id?: string,
  queryParams?: UseQueryOptions<any, Error, any, ["inventorysetupDetail", string | undefined]>
) =>
  useQuery<any, Error, any, ["inventorysetupDetail", string | undefined]>({
    queryKey: ["inventorysetupDetail", id],
    queryFn: () => fetchInventorySetupDetail(String(id)),
    enabled: Boolean(id),
    ...(queryParams as any),
  });

export default useGetInventorySetupDetailQuery;


